import { Response } from 'miragejs';
import { StatusCodes as HTTP } from 'http-status-codes';

export default server => {
    server.get('/alerts/:id', (schema, { params: { id } }) => {
        const { models: modelItems } = schema.alerts.where(alert => alert.searchId === id);

        return modelItems;
    });

    server.post('/alerts', (schema, { requestBody }) => {
        const parsedRequestBody = JSON.parse(requestBody);

        const { attrs } = schema.alerts.create(parsedRequestBody);

        return attrs;
    });

    server.put('/alerts/:id', (schema, { params: { id }, requestBody }) => {
        const alert = schema.alerts.find(id);

        if (!alert) {
            return new Response(HTTP.NOT_FOUND);
        }

        const parsedRequestBody = JSON.parse(requestBody);

        alert.update(parsedRequestBody);

        return alert.attrs;
    });

    server.post('/alerts/:id/toggle-state', (schema, { params: { id } }) => {
        const alert = schema.alerts.find(id);

        if (!alert) {
            return new Response(HTTP.NOT_FOUND);
        }

        alert.update({ isMuted: !alert.isMuted });

        return alert.attrs;
    });

    server.delete('/alerts/:id', (schema, { params: { id } }) => {
        const alert = schema.alerts.find(id);

        if (alert) {
            alert.destroy();
        }

        return new Response(HTTP.NO_CONTENT);
    });
};
